import { render, staticRenderFns } from "./TableSimple.vue?vue&type=template&id=5390e4cb"
import script from "./TableSimple.vue?vue&type=script&lang=js"
export * from "./TableSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports